export default "__VITE_ASSET__78e06069__"